/**
 * A Fallback SVG icon when an app icon cannot be loaded.
 * @internal
 */
export const FallbackIcon = (props: { size: number }) => {
  const size = props.size;
  return (
    <div style={{ height: size }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 256 256"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation"
        aria-hidden="true"
      >
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M73.9961 20C44.1749 20 20 44.1749 20 73.9961V182.014C20 211.835 44.1749 236.01 73.9961 236.01H182.004C211.825 236.01 236 211.835 236 182.014V73.9961C236 44.1749 211.825 20 182.004 20H73.9961ZM134.41 120.198C127.49 126.226 119.592 133.105 119.592 149.213H130.834C130.834 136.812 137.512 131.477 144.17 126.157C150.791 120.868 157.393 115.593 157.393 103.403C157.393 86.5401 143.903 76.282 126.618 76.282C111.301 76.282 100.762 84.4323 95.9844 95.9552L106.383 101.436C110.599 92.8637 118.187 87.5238 127.18 87.5238C136.877 87.5238 144.605 93.9879 144.605 103.684C144.605 111.318 139.805 115.499 134.41 120.198ZM125.775 161.158C120.576 161.158 117.063 164.811 117.063 169.87C117.063 174.929 120.576 178.583 125.775 178.583C130.834 178.583 134.488 174.929 134.488 169.87C134.488 164.811 130.834 161.158 125.775 161.158Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
